import { SearchInput } from "PFApp/components/search_input";
import { ActionIcon } from "PFComponents/action_icon";
import { PillTab, PillTabs } from "PFComponents/tabs/pill_tabs";
import { Typography } from "PFComponents/typography";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { ImportModalPage } from "../../constants/import_modal_page";
import { useImportSkillsModalContext } from "../../contexts/import_skills_modal_context";
import { useImportsHistory } from "../../hooks/use_imports_history";
import css from "./import_modal_header.module.scss";

type ImportModalHeaderProps = {
  handleClose?: VoidFunction;
};

export const ImportModalHeader = ({ handleClose }: ImportModalHeaderProps): JSX.Element => {
  const { t } = useTranslation("skillsManagement", { keyPrefix: "header.modals.import" });
  const { currentPage, setCurrentPage, search, setSearch } = useImportSkillsModalContext();
  const { counter: importsCounter } = useImportsHistory({ page: 1, perPage: 0 });

  const tabs: PillTab<ImportModalPage>[] = useMemo(
    () => [
      {
        id: ImportModalPage.Upload,
        label: t("newImport")
      },
      {
        id: ImportModalPage.ImportHistory,
        count: importsCounter,
        label: t("importHistory")
      }
    ],
    [importsCounter, t]
  );

  const selectedPage = useMemo(
    () =>
      ({
        [ImportModalPage.Upload]: ImportModalPage.Upload,
        [ImportModalPage.ImportSuccess]: ImportModalPage.Upload,
        [ImportModalPage.ImportError]: ImportModalPage.Upload,
        [ImportModalPage.ImportHistory]: ImportModalPage.ImportHistory,
        [ImportModalPage.ImportDataTable]: ImportModalPage.ImportHistory
      }[currentPage]),
    [currentPage]
  );

  return (
    <header className={css.header}>
      <span className={css.horizontalLayout}>
        <Typography variant="h4" noMargin>
          {t("importSkills")}
        </Typography>
        <ActionIcon name="cross" size="xs" onClick={handleClose} />
      </span>
      <div className={css.horizontalLayout}>
        <PillTabs<ImportModalPage> tabs={tabs} selectedId={selectedPage} onTabClick={setCurrentPage} />
        {currentPage === ImportModalPage.ImportHistory && (
          <SearchInput onTermChange={setSearch} term={search || ""} />
        )}
      </div>
    </header>
  );
};
